import React from 'react';
import PropTypes from 'prop-types';
import useEmblaCarousel from 'embla-carousel-react';
import FeatureOption from './FeatureOption';

/**
 * Feature group component (e.g., "Eyebrows" with all eyebrow options)
 */
const FeatureGroup = ({ title, options, selected = null, onChange, optional = false }) => {
    const [emblaRef] = useEmblaCarousel({ align: 'start', dragFree: true });

    if (!options || options.length === 0) {
        return null;
    }

    const handleClearSelection = () => {
        onChange(null);
    };

    return (
        <div className="head-builder-feature-group">
            <h3 className="head-builder-feature-title">
                {title}
                {optional && <span className="head-builder-optional-label"> (optional)</span>}
            </h3>
            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                    {optional && selected && (
                        <div className="embla__slide">
                            <button
                                type="button"
                                className="head-builder-option head-builder-option-none"
                                onClick={handleClearSelection}
                            >
                                <div className="head-builder-option-image">
                                    <span className="head-builder-none-icon">✕</span>
                                </div>
                                <span className="head-builder-option-title">None</span>
                            </button>
                        </div>
                    )}
                    {options.map((option) => (
                        <div key={option.id} className="embla__slide">
                            <FeatureOption
                                option={option}
                                isSelected={selected === option.handle}
                                onClick={() => onChange(option.handle)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

FeatureGroup.propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            handle: PropTypes.string.isRequired,
        })
    ).isRequired,
    selected: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    optional: PropTypes.bool,
};

export default FeatureGroup;
